<div class="row" style="min-height: 500px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-12">
            <div class="tablewrap">
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{'lang.globals.restoreCode' | translate}}</p>
                  <p class="w-100 tr" style="margin: -20px 0 -20px -20px;">
                    <input (ngModelChange)="onRestoreCode($event)" [ngModel]="restoreCode"
                           class="form-control text-end" placeholder="..."
                           type="text">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{'lang.globals.vaildTill' | translate}}</p>
                  <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                    <sb-local-date-time-input (modelChange)="changeTill($event)"></sb-local-date-time-input>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100 tr"></p>
                  <p class="w-100 tr">
                    <button (click)="ok()" [disabled]="!restoreCode || restoreCode?.length < 8"
                            class="btn btn-primary mr-2">{{'lang.globals.ok' | translate}}</button>
                    <button (click)="cancel()"
                            class="btn btn-secondary">{{'lang.globals.cancel' | translate}}</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
